module.exports = __webpack_public_path__ + "static/UHost-b10ac9628b3309b6306855b163150891.png";